// eslint-disable-next-line import/extensions
import { createColumnFactory } from '@/AgGridComponents/columnFactory';

export function buildProcessChargesStopsColumns(vm) {
    const col = createColumnFactory();
    return [
        // Default visible
        col({
            headerName: '',
            checkboxSelection: true,
            headerComponent: 'PageHeaderCheckbox',
            minWidth: 50,
            maxWidth: 50,
            lockPosition: 'left',
            sortable: false,
            filter: false,
            suppressMenu: true,
            resizable: false
        }),
        col({
            headerName: 'Reference Number',
            field: 'stopRef',
            type: 'text',
            width: 180,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer('Stop Details', { stopId: params.data.stopId }, params.value)
        }),
        col({
            headerName: 'Trip Date',
            field: 'tripDate',
            type: 'date',
            valueFormatter: vm.$_dateFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Customer',
            field: 'customerName',
            type: 'boolean',
            width: 180,
            keyCreator: (params) => (params.value ? params.value.name : ''),
            filterParams: {
                values: vm.loadCustomerList,
                valueFormatter: (params) => (params.value ? params.value.name : ''),
                selectAllOnMiniFilter: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Delivered By',
            field: 'driverName',
            type: 'boolean',
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Team Member Profile',
                    { publicUserId: params.data.driverPublicUserId },
                    params.value
                ),
            keyCreator: (params) => (params.value ? params.value.fullName : ''),
            filterParams: {
                values: vm.loadTeamMembers,
                valueFormatter: (params) => (params.value ? params.value.fullName : ''),
                selectAllOnMiniFilter: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Status',
            field: 'status',
            type: 'boolean',
            width: 120,
            keyCreator: (params) => {
                if (params.value === 'Complete') {
                    return 'Complete';
                }
                if (params.value === 'Failed') {
                    return 'Failed';
                }
                return null;
            },
            filterParams: {
                values: ['All', 'Complete', 'Failed'],
                valueFormatter: (params) => (params.value ? params.value : ''),
                suppressMiniFilter: true,
                suppressSelectAll: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Costs Approved',
            field: 'isCostsApproved',
            type: 'boolean',
            valueFormatter: vm.$_booleanFormatter,
            keyCreator: (params) => {
                if (params.value === 'Yes') {
                    return 'true';
                }
                if (params.value === 'No') {
                    return 'false';
                }
                return 'true';
            },
            filterParams: {
                values: ['Yes', 'No'],
                valueFormatter: (params) => (params.value ? params.value : ''),
                suppressMiniFilter: true,
                suppressSelectAll: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Charges Approved',
            field: 'isChargesApproved',
            type: 'boolean',
            valueFormatter: vm.$_booleanFormatter,
            keyCreator: (params) => {
                if (params.value === 'Yes') {
                    return 'true';
                }
                if (params.value === 'No') {
                    return 'false';
                }
                return 'true';
            },
            filterParams: {
                values: ['Yes', 'No'],
                valueFormatter: (params) => (params.value ? params.value : ''),
                suppressMiniFilter: true,
                suppressSelectAll: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Total Charge',
            field: 'nettCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Total Cost',
            field: 'nettCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Source Reference',
            field: 'sourceReference',
            type: 'text',
            width: 180,
            hide: true
        }),
        col({
            headerName: 'Team Region Name',
            type: 'boolean',
            field: 'teamRegionId',
            valueFormatter: (params) => {
                return params.data.teamRegionName
            },
            keyCreator: (params) => (params.value ? String(params.value.teamRegionId) : ''),
            filterValueGetter: (params) => params.data.teamRegionId,
            filterParams: {
                values: vm.loadTeamRegions,
                valueFormatter: (params) => {

                    return params.value ? params.value.name : '';
                },
                selectAllOnMiniFilter: true
            },
        }),
        col({
            headerName: 'Team Region Code',
            field: 'teamRegionCode',
            type: 'boolean',
            hide: true,
            keyCreator: (params) => {
                if (params.value != null && params.value.teamRegionId == null) {
                    return null;
                }
                return params.value ? params.value.teamRegionCode : null;
            },
            filterParams: {
                values: vm.loadTeamRegionCode,
                valueFormatter: (params) => (params.value ? params.value.teamRegionCode : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Drop Address',
            field: 'dropAddress',
            type: 'text',
            width: 250,
            hide: true
        }),
        col({
            headerName: 'Run #',
            field: 'runNumber',
            type: 'number',
            width: 110,
        }),
        col({
            headerName: 'Attempt',
            field: 'attempt',
            type: 'number',
            width: 100,
        }),
        col({
            headerName: 'Scheduled Time',
            field: 'scheduledDateTime',
            type: 'text',
            valueFormatter: vm.$_timeFormatter,
            floatingFilter: false
        }),
        col({
            headerName: 'Actual Completed Time',
            field: 'actualCompletedDateTime',
            type: 'text',
            valueFormatter: vm.$_timeFormatter,
            floatingFilter: false
        }),
        col({
            headerName: 'Service Package (Costs)',
            field: 'rateGroupNameCosts',
            type: 'boolean',
            width: 170,
            keyCreator: (params) => {
                if (params.value != null && params.value.rateGroupId == null) {
                    return null;
                }
                return params.value ? params.value.rateGroupName : null;
            },
            filterParams: {
                values: vm.loadServicePackageList,
                valueFormatter: (params) => (params.value ? params.value.rateGroupName : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Service Package (Charges)',
            field: 'rateGroupNameCharges',
            type: 'text',
            width: 170,
            hide: true
        }),
        col({
            headerName: 'Team Member Invoice #',
            field: 'teamMemberInvoiceNumber',
            type: 'text',
            width: 190,
            hide: true,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Team Member Invoice Details',
                    { invoiceId: params.data.teamMemberInvoiceId },
                    params.value
                )
        }),
        col({
            headerName: 'Customer Invoice #',
            field: 'customerInvoiceNumber',
            type: 'text',
            width: 190,
            hide: true,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Customer Invoice Details',
                    { invoiceId: params.data.customerInvoiceId },
                    params.value
                )
        }),
        col({
            headerName: 'Base Charge',
            field: 'baseCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Fuel Levy Charge',
            field: 'fuelLevyCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Surcharge Charge',
            field: 'surchargeCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Total Other Charges',
            field: 'totalOtherCharges',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Base Cost',
            field: 'baseCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Fuel Levy Cost',
            field: 'fuelLevyCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Surcharge Cost',
            field: 'surchargeCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Total Other Costs',
            field: 'totalOtherCosts',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Margin',
            field: 'margin',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120,
        }),
        col({
            headerName: 'Margin %',
            field: 'marginPercent',
            type: 'percent',
            valueFormatter: vm.$_percentFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Previous Attempt Stop Ref',
            field: 'previousAttemptStopRef',
            type: 'text',
            width: 180,
            hide: true
        }),
        col({
            headerName: 'Previous Attempt Status',
            field: 'previousAttemptStatus',
            type: 'text',
            width: 180,
            hide: true
        }),
        col({
            headerName: 'Actions',
            cellRenderer: 'ActionRendererProcessCharges',
            cellRendererParams: (params) =>
                vm.$_actionParameterCellRenderer(params, 'stop', vm.triggerRecalculate.bind(vm), vm.fetchStop.bind(vm)),
            sortable: false,
            width: 160,
            pinned: 'right'
        })
    ];
}

export default buildProcessChargesStopsColumns;
